import React from 'react';
import { SyncEventNotificationErrorCode } from '@bechtel/types';
import { ApolloError } from '@apollo/client';
import { Trans } from '@lingui/macro';

export const getError = (error) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case SyncEventNotificationErrorCode.EVENT_NOTIFICATION_ALREADY_PROCESSED:
      return <Trans>Event Notification Already Processed.</Trans>;
    case SyncEventNotificationErrorCode.EVENT_NOTIFICATION_ENTITY_NOT_CONFIGURED:
      return <Trans>Event Notificatio Entity Not Configured.</Trans>;
    case SyncEventNotificationErrorCode.EVENT_NOTIFICATION_NOT_FOUND:
      return <Trans>Event Notification Not Found.</Trans>;
    case SyncEventNotificationErrorCode.EVENT_NOTIFICATION_PUB_SUB_NOT_CONFIGURED:
      return <Trans>Event Notification Pub Sub Not Configured</Trans>;
    case SyncEventNotificationErrorCode.FILTER_VALUES_MISSING:
      return <Trans>Filter Values Missing</Trans>;
    case SyncEventNotificationErrorCode.INVALID_ENTITY_TYPE_VALUE:
      return <Trans>Invalid Entity Type Value .</Trans>;
    case SyncEventNotificationErrorCode.INVALID_ERROR_TYPE_VALUE:
      return <Trans>Invalid Entity Type Value .</Trans>;
    case SyncEventNotificationErrorCode.INVALID_FILTER_OPERATOR:
      return <Trans>Invalid Error Type Value</Trans>;
    case SyncEventNotificationErrorCode.INVALID_FILTER_VALUE:
      return <Trans>Invalid Filter Value .</Trans>;
    case SyncEventNotificationErrorCode.INVALID_NOTIFICATION_TYPE_ID_VALUE:
      return <Trans>Invalid Notification Type Id Value</Trans>;
    case SyncEventNotificationErrorCode.INVALID_STATUS_VALUE:
      return <Trans>Invalid Status Value</Trans>;
    case SyncEventNotificationErrorCode.INVALID_SYNC_SCHEDULE_VALUE:
      return <Trans>Invalid Sync Schedule Value</Trans>;
    case SyncEventNotificationErrorCode.PENDING_EVENT_NOTIFICATION_FOUND:
      return <Trans>Pending Event Notification Found</Trans>;
    case SyncEventNotificationErrorCode.SYNC_EVENT_NOTIFICATION_FAILED:
      return <Trans>Sync Event Notification Failed</Trans>;
    case SyncEventNotificationErrorCode.SYNC_EVENT_NOTIFICATION_SCHEDULE_FAILED:
      return <Trans>Sync Event Notification Schedule Failed</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};
